import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Box } from 'rebass';

import { Text } from '../Base';
import { SPACE } from '../Theme';
import { SolutionListTable } from '../Table';

import { Header } from './Subcomponents';

export default class SolutionGroups extends Component {
  static propTypes = {
    sections: PropTypes.array,
    renderActionRow: PropTypes.func,
  };
  static defaultProps = {
    sections: [],
  };

  render() {
    const { sections, renderActionRow } = this.props;
    return (
      <Box mt={SPACE.large}>
        <Text.Title mb={SPACE.large}>เฉลยละเอียด</Text.Title>
        {sections.map(section => (
          <Box mb={SPACE.large} key={section.title}>
            <Header cap title={section.title} />
            <SolutionListTable rows={section.rows} renderActionRow={renderActionRow} />
          </Box>
        ))}
      </Box>
    );
  }
}
